__turbopack_context__.v({
  "navbarSearch": "styles-module-scss-module__a6kIAa__navbarSearch",
});
